export default __webpack_public_path__ + "static/media/logo.707bef6c.png";